import {dashV2Path} from 'components/StatsPage2.utils';

export const reviewPath = sessionUser => {
  const adminSegment = `/admin/${sessionUser.id}`;
  const managerSegment = `/manager/${sessionUser.id}`;
  const adminView = sessionUser.isAdmin();

  // Maintain admin/manager url if it exists
  return adminView
    ? `/${dashV2Path}${adminSegment}${managerSegment}/coaching-plans`
    : `/${dashV2Path}${managerSegment}/coaching-plans`;
};
